import { Schema } from "effect";
import { ApiEnvironmentIdSchema, ApiProjectIdSchema, UserIdSchema, WorkspaceIdSchema } from "./ids";
import { IsoDateTimeSchema, PapersFlowBoundaryParseOptions } from "./standard";

export const ApiProjectNameSchema = Schema.Trim.check(
  Schema.isMinLength(1),
  Schema.isMaxLength(80),
);
export const ApiEnvironmentNameSchema = Schema.Trim.check(
  Schema.isMinLength(1),
  Schema.isMaxLength(80),
);
export const ApiProjectStatusSchema = Schema.Literals(["active", "archived"]);
export const ApiEnvironmentKindSchema = Schema.Literals([
  "development",
  "staging",
  "production",
  "custom",
]);
export const ApiEnvironmentStatusSchema = Schema.Literals(["active", "disabled"]);

export const ApiProjectSchema = Schema.Struct({
  id: ApiProjectIdSchema,
  workspaceId: WorkspaceIdSchema,
  name: ApiProjectNameSchema,
  status: ApiProjectStatusSchema,
  createdBy: UserIdSchema,
  createdAt: IsoDateTimeSchema,
  updatedAt: IsoDateTimeSchema,
  archivedAt: Schema.optionalKey(IsoDateTimeSchema),
});

export const ApiEnvironmentSchema = Schema.Struct({
  id: ApiEnvironmentIdSchema,
  workspaceId: WorkspaceIdSchema,
  apiProjectId: ApiProjectIdSchema,
  name: ApiEnvironmentNameSchema,
  kind: ApiEnvironmentKindSchema,
  status: ApiEnvironmentStatusSchema,
  createdAt: IsoDateTimeSchema,
  updatedAt: IsoDateTimeSchema,
});

export const decodeApiProject = Schema.decodeUnknownSync(
  ApiProjectSchema,
  PapersFlowBoundaryParseOptions,
);
export const encodeApiProject = Schema.encodeSync(ApiProjectSchema, PapersFlowBoundaryParseOptions);
export const decodeApiEnvironment = Schema.decodeUnknownSync(
  ApiEnvironmentSchema,
  PapersFlowBoundaryParseOptions,
);
export const encodeApiEnvironment = Schema.encodeSync(
  ApiEnvironmentSchema,
  PapersFlowBoundaryParseOptions,
);
export const decodeApiProjectName = Schema.decodeUnknownSync(
  ApiProjectNameSchema,
  PapersFlowBoundaryParseOptions,
);
export const decodeApiEnvironmentName = Schema.decodeUnknownSync(
  ApiEnvironmentNameSchema,
  PapersFlowBoundaryParseOptions,
);
export const decodeApiEnvironmentKind = Schema.decodeUnknownSync(
  ApiEnvironmentKindSchema,
  PapersFlowBoundaryParseOptions,
);

export type ApiProjectStatus = typeof ApiProjectStatusSchema.Type;
export type ApiEnvironmentKind = typeof ApiEnvironmentKindSchema.Type;
export type ApiEnvironmentStatus = typeof ApiEnvironmentStatusSchema.Type;
export type ApiProject = typeof ApiProjectSchema.Type;
export type ApiProjectEncoded = typeof ApiProjectSchema.Encoded;
export type ApiEnvironment = typeof ApiEnvironmentSchema.Type;
export type ApiEnvironmentEncoded = typeof ApiEnvironmentSchema.Encoded;
